'use client';

import { useInView } from '@/lib/hooks';
import { cn } from '@/lib/utils';
import { PathEnum } from '@/types/enums';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import Button from '../ui/Button';
import Link from '../ui/Link';
import P from '../ui/P';

export interface Service {
    imageSrc: string;
    title: string;
    text: string;
    link: PathEnum;
}

export default function ServiceCard({ imageSrc, title, text, link }: Service) {
    const t = useTranslations('AllServices');
    const { isInView, elementRef } = useInView();

    return (
        <div
            className={cn(
                'flex flex-col p-[30px] drop-shadow-xs gap-4 opacity-0 transition-all duration-1000 ease-in-out bg-light-grey rounded-10 min-h-[420px] w-full max-w-full lg:max-w-[350px]',
                isInView && 'opacity-100',
            )}
            ref={elementRef}
        >
            <Image
                className="object-contain min-h-[166px]"
                src={imageSrc}
                alt="Service"
                width={132}
                height={150}
            />
            <h3 className="font-medium text-h3 text-dark-grey leading-tight break-words">
                {title}
            </h3>
            <P className="line-clamp-4">{text}</P>
            <Link className="w-fit mt-auto" href={link} ariaLabel={t('readMore')}>
                <>
                    <span className="sr-only">{t('readMore')}</span>
                    <Button title={t('readMore')} withArrow variant="secondary" />
                </>
            </Link>
        </div>
    );
}
